module.exports = __webpack_public_path__ + "img/DSC_0180 teatro 4.5d57c9e2.jpg";